import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import Loader from 'core/react/general/Loader';
import InputPicker from 'core/react/general/form/InputPicker';
import { zoneGuardsListSelector } from 'core/redux/selectors/zoneGuards';

interface IZoneGuardsSelectProps {
  value: number | null;
  onChange: (value: number) => void;
}

export const ZoneGuardsSelect: FC<IZoneGuardsSelectProps> = (props) => {
  const zoneGuards = useSelector(zoneGuardsListSelector);

  const options = zoneGuards
    ?.filter((zoneGuard) => !!zoneGuard.musteringCategoryIds?.length)
    ?.map(({ name, processorId }) => ({
      label: name,
      value: processorId,
    }));

  return (
    <div>
      {zoneGuards ? (
        <InputPicker data={options} placeholder="Select Zone Guard" cleanable={false} {...props} />
      ) : (
        <Loader size={Loader.Size.MD} />
      )}
    </div>
  );
};
